import { chains } from "@/src/evm/chains/index.js";
import { Protocol } from "@/src/evm/enums.js";
import { resolvers } from "@/src/evm/releases/resolvers.js";
import type { Sablier } from "@/src/types.js";
import aliases from "./aliases.js";
import manifest from "./manifest.js";

function get(chainId: number, contractMap: Sablier.EVM.ContractMap): Sablier.EVM.Deployment {
  return resolvers.deployment.standard({
    aliasMap: aliases,
    chainId,
    contractMap,
    protocol: Protocol.Lockup,
    version: "v4.0",
  });
}

/**
 * @description Mainnet deployments for Lockup v4.0
 */
export const mainnets: Sablier.EVM.Deployment[] = [
  get(chains.abstract.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x63Ff2E370788C163D5a1909B5FCb299DB327AEF9",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x5Ed8660672aFDd2bb991b4c9097dbB2e0a6BcB6C",
    [manifest.SABLIER_LOCKUP]: ["0x2a8887a7Cc494e35EEB615df34026DBfaE027a5C", 46_424_742],
  }),
  get(chains.arbitrum.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xd5c6a0Dd2E1822865c308850b8b3E2CcE762D061",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x629AC39918E97ccAF5908e74dEE1bFea0489FE95",
    [manifest.SABLIER_LOCKUP]: ["0xD103611856F3c2BbAe61D9bF138078794fC09C33", 442_712_696],
  }),
  get(chains.avalanche.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x906A4BD5dD0EF13654eA29bFD6185d0d64A4b674",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x3813bc15b71aEB1E4ea301c4DE37b43B0cd6b3aC",
    [manifest.SABLIER_LOCKUP]: ["0xB891b41533776Ec20f7738c647a11506AA44b8A8", 80_574_676],
  }),
  get(chains.base.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x87e437030b7439150605a641483de98672E26317",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xE001bae5Ef0d86362Ca258bff994a97CAE1245F5",
    [manifest.SABLIER_LOCKUP]: ["0xc19a09A66887017F603E5dF420ed3Cb9a5c07C0A", 43_478_436],
  }),
  get(chains.berachain.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x3bbE0a21792564604B0fDc00019532Adeffa70eb",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xfC8153d02464374C96683F09FE2B24065A03A64C",
    [manifest.SABLIER_LOCKUP]: ["0x2455c72a4aFE3b0e2B26b5EFD7F8EFFE6B828C90", 18_365_748],
  }),
  get(chains.bsc.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x56831a5a932793E02251126831174Ab8Bf2f7695",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xF90ca72fa2CC584Db0Ee2F34ac2f54DAfBe7C045",
    [manifest.SABLIER_LOCKUP]: ["0x6cd06Aaf06506bC3fF382d83023354E2B80EeD22", 87_110_015],
  }),
  get(chains.chiliz.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x8A96f827082FB349B6e268baa0a7A5584c4Ccda6",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xE47A0D9081035a6aB8e4f5c29B6BA396A303cA16",
    [manifest.SABLIER_LOCKUP]: ["0x003b2D58A97315CE9fB3888Db6BCB9770e73f398", 32_333_444],
  }),
  get(chains.denergy.id, {
    [manifest.LOCKUP_HELPERS]: "0x2eFEa83cAbF1c3357Ba7661a32AaE5bc74A5aFD6",
    [manifest.LOCKUP_MATH]: "0x2e5ad3dE34C0f36B3f96a7F740Db2d9b4BAd0b33",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x4749dB4834be9b473D586Ad4d98133dAfC678313",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x29F5527C7CdBe1548dE5634D295FD7DAC3AD327D",
    [manifest.SABLIER_LOCKUP]: ["0xB9636F3dc2Fc1B5Ad2a7323210084DBEeD7B2377", 3_448_842],
  }),
  get(chains.mainnet.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xA9dC6878C979B5cc1d98a1803F0664ad725A1f56",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x4f3be262D1358A82b468CF81bfc5A9cC32Cf9875",
    [manifest.SABLIER_LOCKUP]: ["0x93b37Bd5B6b278373217333Ac30D7E74c85fBDCB", 24_676_697],
  }),
  get(chains.gnosis.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x3140a6900AA2FF3186730741ad8255ee4e6d8Ff1",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x653Cbc0cC19dCb43F06a0d0909835a9d7dec33dF",
    [manifest.SABLIER_LOCKUP]: ["0xF24e804B0Eb4fC0eAD41dF0e392D25fb230Bbab4", 45_195_064],
  }),
  get(chains.hyperevm.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x7263d77e9e872f82A15e5E1a9816440D23758708",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xCBFaA5f5d0DB294eeb726334b16f75e4d7AfB5fe",
    [manifest.SABLIER_LOCKUP]: ["0x5369E34C92EACC1cceaFFe1be01F057C68ca1b19", 29_984_262],
  }),
  get(chains.lightlink.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xCFB5F90370A7884DEc59C55533782B45FA24f4d1",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x2621819f84Ef7a8424e7A8Ff573b7Fe595856D41",
    [manifest.SABLIER_LOCKUP]: ["0xa39376a844dB3aA3fAaF119321b761cfE296fe19", 196_373_963],
  }),
  get(chains.linea.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x1514a869D29a8B22961e8F9eBa3DC64000b96BCe",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xa0B12148210bD25F739bEA4824A35F071989F60a",
    [manifest.SABLIER_LOCKUP]: ["0xFb898e1626c9B32F89fFB0FedD145B89590d219e", 29_763_571],
  }),
  get(chains.mode.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x64e7879558b6dfE2f510bd4b9Ad196ef0371EAA8",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x0d3cd659d417c45ac6A79db594848fCd34583671",
    [manifest.SABLIER_LOCKUP]: ["0x43916BAb157B56124C46dC09D45A9516489D84B7", 36_791_354],
  }),
  get(chains.monad.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x37BA02a35861F7254fAE733E3a7cADD96D9D32A2",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xB02d463F531c3eB1a92B18B9d4756e9d03AB2562",
    [manifest.SABLIER_LOCKUP]: ["0x82723C1ffEc9D43dE5FA80b25Da8df99AfD470ba", 62_013_941],
  }),
  get(chains.morph.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x660314f09ac3B65E216B6De288aAdc2599AF14e2",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x9F8A023c90ab65cAf8eE4D7e1248E883e2B74A36",
    [manifest.SABLIER_LOCKUP]: ["0xA74F2Cf047A67509f332DD9B2D6D51989e546548", 21_502_833],
  }),
  get(chains.optimism.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x41dBa1AfBB6DF91b3330dc009842327A9858Cbae",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x9A8486b4D65134197A42076559e4A8CA9917f289",
    [manifest.SABLIER_LOCKUP]: ["0x945ba0D0EeAa5766d4bae5455a9817D7ae150550", 149_075_526],
  }),
  get(chains.polygon.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xf5e12d0bA25FCa0D738Ec57f149736B2e4C46980",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x052c85cB2Db728d5A7709D41f648016469C09388",
    [manifest.SABLIER_LOCKUP]: ["0xCEb5253Db890347D45778FB0834fb3c0B57aFf93", 84_316_024],
  }),
  get(chains.robinhood.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x37BA02a35861F7254fAE733E3a7cADD96D9D32A2",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x37c434Ec1C54e360900e3A022247d5e20137c1de",
    [manifest.SABLIER_LOCKUP]: ["0x548129a58bC230549DF7F9e33f27E77F6779ff0f", 10_420_411],
  }),
  get(chains.scroll.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x00Ff6443E902874924dd217c1435e3be04f57431",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x92CB40d8De23A4C657d03F4a926Dd684FfB74063",
    [manifest.SABLIER_LOCKUP]: ["0x9435E262A4A312d30D6C41fE055f648e91Af411e", 32_070_866],
  }),
  get(chains.sonic.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x955dC7A2170782344FA9Ac11De0C0C42C05De2Fc",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x414e7871fDEbFCDd82095431CB3b5B1C9f8f4d25",
    [manifest.SABLIER_LOCKUP]: ["0xa697988451F921185A8c824aD4867DC8933C4ECB", 65_562_236],
  }),
  get(chains.superseed.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xa4576b58Ec760A8282D081dc94F3dc716DFc61e9",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xD68f7514Abadad1CAF00B4606f43d03109ad1373",
    [manifest.SABLIER_LOCKUP]: ["0x3AC18F736d0E1B9bd9259Cd6C8a43539C86C16fD", 23_786_199],
  }),
  get(chains.unichain.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xa5F12D63E18a28C9BE27B6f3d91ce693320067ba",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x838478f87d2A907DE53862c1B36b919b5e19FCEa",
    [manifest.SABLIER_LOCKUP]: ["0xE72830E2845B74aA3bA71fB6E833D7A677129793", 43_003_738],
  }),
  get(chains.xdc.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x4c1311a9d88BFb7023148aB04F7321C2E91c29bf",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xFE9B690173DbFDf4Ad937A0555AFb32D50A26daD",
    [manifest.SABLIER_LOCKUP]: ["0x16f5c4Ddc5b828F00E8f92267f3ABf60b700dB5c", 100_412_659],
  }),
  get(chains.zksync.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x955dC7A2170782344FA9Ac11De0C0C42C05De2Fc",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x02Dec2d93E47e2d5Fda3969E45B16BAf42ebA607",
    [manifest.SABLIER_LOCKUP]: ["0xc2FDF5DCDEaa1F7c83e569D03b22eA8636073F4A", 69_121_942],
  }),
];

/**
 * @description Testnet deployments for Lockup v4.0
 */
export const testnets: Sablier.EVM.Deployment[] = [
  get(chains.arbitrumSepolia.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x8224eb5D7d76B2D7Df43b868D875E79B11500eA8",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x77DA2e9939D45031A6C003A227fB13F683b288F0",
    [manifest.SABLIER_LOCKUP]: ["0xe4E4ecC586A79aAeAb423B2C6da8F7510de811c5", 250_882_899],
  }),
  get(chains.baseSepolia.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xCA2593027BA24856c292Fdcb5F987E0c25e755a4",
    [manifest.SABLIER_BATCH_LOCKUP]: "0x41813cE5F8CF780ba1429A24512f90AaAEFb8144",
    [manifest.SABLIER_LOCKUP]: ["0xA65A1ecEf02C2B9BDc604951c6A6D02335D4532e", 38_985_887],
  }),
  get(chains.optimismSepolia.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0xDf6163ddD3Ebcb552Cc1379a9c65AFe68683534e",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xB5549e9348ce9E0D461e0f8b9F05173E052Ef312",
    [manifest.SABLIER_LOCKUP]: ["0x9D68477ef056552D769752171f348B74E0050Fe8", 40_969_002],
  }),
  get(chains.sepolia.id, {
    [manifest.LOCKUP_HELPERS]: "0xC86B56250D2758f30d09B3420D9ec5b646244C7c",
    [manifest.LOCKUP_MATH]: "0x6c873BcE27aA6Ca803EF7013F05d1802AB6995b6",
    [manifest.LOCKUP_NFT_DESCRIPTOR]: "0x955dC7A2170782344FA9Ac11De0C0C42C05De2Fc",
    [manifest.SABLIER_BATCH_LOCKUP]: "0xd4ddc49F9D03a48293b5c8d89Cc210Af49d03D72",
    [manifest.SABLIER_LOCKUP]: ["0xe61cb9153356419bdaD0A8767c059f92d221a3C4", 10_463_080],
  }),
];
